import { Injectable } from '@angular/core';

import { GroupService } from '@alfresco/adf-content-services';
import { GroupEntry } from '@alfresco/js-api';

@Injectable({
  providedIn: 'root',
})
export class WkGroupService {
  constructor(private readonly groupService: GroupService) {}

  listAllGroupMembershipsForPerson(
    personId: string,
    opts: { [key: string]: any } = {},
    accumulator = []
  ): Promise<GroupEntry[]> {
    return this.groupService.listAllGroupMembershipsForPerson(
      personId,
      opts,
      accumulator
    );
  }
}
